import { apiClient } from '@/services/ApiClient.js'

export class RoleService {
  query

  constructor(query) {
    this.query = query
  }

  getRoles() {
    return apiClient
      .get('roles', {
        params: this.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getRole(id) {
    return apiClient
      .get('roles/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  createRole(role) {
    return apiClient
      .post('roles', role)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateRole(id, role) {
    return apiClient
      .patch('roles/' + id, role)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  destroyRole(id) {
    return apiClient
      .delete('roles/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getPermissions(id) {
    return apiClient
      .get('roles/' + id + '/permissions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  detachPermission(roleId, id) {
    return apiClient
      .delete('roles/' + roleId + '/permissions/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  attachPermissions(roleId, permissions) {
    return apiClient
      .post('roles/' + roleId + '/permissions', permissions)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
